import type { IItem } from '../../interfaces/organizations';
import type { GlobalState } from '../index';

export const selectOrganizations = (state: GlobalState) => state.organizations;
export const selectOrganizationsList = (state: GlobalState) => state.organizations.organizationsList;

export const selectOrganizationsDetails = (state: GlobalState) => state.organizations.details;
export const selectOrganizationDetails = (alias: string) => (state: GlobalState): IItem => {
  const detailsState = selectOrganizationsDetails(state);

  return detailsState.data[detailsState.infoAliasMap[alias]] || {};
};

export const selectOrganizationsMenu = (state: GlobalState) => state.organizations.menu;
export const selectOrganizationMenuByAlias = (alias: string) => (state: GlobalState) => state.organizations.menu[alias];

export const selectOrganizationDependencyCounts = (state: GlobalState) => state.organizations.dependencyCounts;

export const selectOrganizationsTotal = (state: GlobalState): number => state.organizations.organizationsTotal;
